import styled from 'styled-components'

export const Container = styled.div`
  max-width: 1200px;
  padding: 0 24px;
  margin: 0 auto;
  box-sizing: initial;

  ${p => p.theme.breakpoints.down('md')} {
    max-width: 960px;
  }
  ${p => p.theme.breakpoints.down('sm')} {
    max-width: 736px;
    padding: 0 16px;
  }
`
